import { LeftBox } from '../blog.style';
import { useRouter } from 'next/router';
import Text from 'common/components/Text';
import PropTypes from 'prop-types';
import { components } from '../../../../slices';
import Box from 'common/components/Box';
import { SliceZone, PrismicRichText } from '@prismicio/react';
import { useEffect, useRef, useState } from 'react';
import TableOfContents from 'common/components/TableOfContent';
import Author from '../Author';
import ShareBox from '../ShareBox';
import { handleScroll, handleScrollGetSated } from './event';
import {
  ShortDescriptionContainer,
  TitleContainer,
  CustomBoxContainer,
  CustomLeftBoxTable,
  CustomBoxTocContainer,
  CustomBoxTypography,
  CustomBoxContentTableMobile,
} from './style';

const Content = ({ data, descriptionStyle, author }) => {
  const [activeSection, setActiveSection] = useState('');
  const [leftBoxContentHeight, setLeftBoxContentHeight] = useState(0);
  const leftBoxRef = useRef(null);
  const router = useRouter();
  const articleUrl = `https://swiftask.ai/${router.asPath}`;

  const generateTableOfContents = (data) => {
    const sectionTitles = data?.slices
      ?.map((slice, index) => {
        const primaryText = slice?.primary?.text;
        if (Array.isArray(primaryText) && primaryText.length > 0) {
          const text = primaryText[0]?.text;
          const textType = primaryText[0]?.type;
          if (text && (textType === 'heading2' || textType === 'heading3')) {
            return {
              id: slice.id,
              title: text,
              type: textType,
            };
          }
        }
        return null;
      })
      .filter((section) => section !== null);
    return sectionTitles;
  };

  const scrollToSection = (event, sectionId) => {
    event.preventDefault();
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      const yOffset = -88;
      const y =
        targetElement.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };
  const tableOfContents = generateTableOfContents(data);

  useEffect(() => {
    const leftBox = window.addEventListener('scroll', () =>
      handleScroll(
        leftBoxRef,
        setLeftBoxContentHeight,
        setActiveSection,
        leftBoxContentHeight,
        tableOfContents,
      ),
    );

    const rigthBox = window.addEventListener('scroll', handleScrollGetSated);

    return () => {
      leftBox;
      rigthBox;
    };
  }, [tableOfContents, leftBoxContentHeight]);

  return (
    <CustomBoxContainer>
      <CustomLeftBoxTable id='customLeftBoxTable'>
        <CustomBoxTocContainer>
          <CustomBoxTypography>Table of contents :</CustomBoxTypography>
          <TableOfContents
            sections={tableOfContents}
            activeSection={activeSection}
            scrollToSection={scrollToSection}
          />
        </CustomBoxTocContainer>
      </CustomLeftBoxTable>
      <LeftBox ref={leftBoxRef}>
        <TitleContainer>
          <Text as='h1' content={data?.title} />
        </TitleContainer>
        <ShortDescriptionContainer>
          <PrismicRichText field={data?.description} />
        </ShortDescriptionContainer>
        <CustomBoxContentTableMobile>
          <TableOfContents
            sections={tableOfContents}
            activeSection={activeSection}
            scrollToSection={scrollToSection}
            isMobile={true}
          />
        </CustomBoxContentTableMobile>
        <Box style={descriptionStyle}>
          <SliceZone slices={data?.slices} components={components} />
        </Box>
        <Author author={author} data={data} />
        <Box>
          <ShareBox articleUrl={articleUrl} />
        </Box>
      </LeftBox>
      
    </CustomBoxContainer>
  );
};
Content.propTypes = {
  descriptionStyle: PropTypes.object,
};
Content.defaultProps = {
  descriptionStyle: {
    // fontFamily: "Montserrat,sans-serif",
    // letterSpacing: ".08em",
    lineHeight: '27px',
    fontSize: '16px',
  },
};
export default Content;
